import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "moment/locale/fr";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import moment from "moment";
import { Site } from "../../interfaces";
import { Tooltip } from "react-tooltip";

interface DataTableSiteProps {
  sites: Site[];
  handleRowSelection: any;
  selectedSites: any;
  openModalDelete: (rowData: any) => void;
  openModalEditSite: (rowData: any) => void;
  openModalStructure: (rowData: any) => void;
  isMaitreOrAdmin: any;
}
const DataTableSite = ({
  sites,
  handleRowSelection,
  selectedSites,
  openModalDelete,
  openModalEditSite,
  openModalStructure,
  isMaitreOrAdmin,
}: DataTableSiteProps) => {
  const [filtersSites, setFiltersSites] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom_site: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });

  const siteBodyTemplate = (rowData) => {
    return (
      <div className="flex items-center w-full  space-x-3 transition-colors duration-200   ">
        <img src="/images/composants.png" className="w-5 h-5 flex-none" />
        <div className="pl-3">
          <div className="text-base font-semibold">{rowData.nom_site}</div>
        </div>
      </div>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <Button
          data-tooltip-id="download-site"
          icon="pi pi-trash"
          rounded
          text
          severity="danger"
          aria-label="Bookmark"
          onClick={() => openModalDelete(rowData)}
        />
         <Tooltip id="download-site" place="top" >    
            Supprimez ce site
          </Tooltip>
        <Button
          data-tooltip-id="modify-site"
          icon="pi pi-pencil"
          rounded
          text
          severity="warning"
          aria-label="Bookmark"
          onClick={() => openModalEditSite(rowData)}
        />
         <Tooltip id="modify-site" place="top" >    
           Modifier votre arborescence
          </Tooltip>
      </>
    );
  };

  const InfoBodyTemplate = (rowData) => {
    return (
     <> <button
        data-tooltip-id="display-site"
        className="inline-flex items-center px-4 py-2 bg-white-600  text-black text-sm font-medium rounded-md"
        onClick={() => openModalStructure(rowData)}
      >
        <img src="/images/info.png" className="w-5 h-5 flex-none" />
      </button>
       <Tooltip id="display-site" place="top" >    
       Consultez l’arborescence
      </Tooltip>
      </>
    );
  };

  const dateBodyTemplate = (rowData) => {
    return (
      <div className="flex items-center">
        {moment(rowData.created_at).format("Do MMMM YYYY")}
      </div>
    );
  };
  return (
    <DataTable
      value={sites}
      removableSort
      paginator
      rows={5}
      stripedRows
      rowsPerPageOptions={[5, 10, 25, 50]}
      filters={filtersSites}
      filterDisplay="menu"
      dataKey="uuid"
      globalFilterFields={["nom_site"]}
      emptyMessage="Pas de site disponible."
      selection={selectedSites}
      onSelectionChange={(e: any) => handleRowSelection(e.value)}
    >
      <Column selectionMode="multiple"></Column>

      <Column
        field="nom_site"
        header="Nom de site"
        body={siteBodyTemplate}
        style={{ maxWidth: "400px" }}
        sortable
        
      ></Column>

      <Column 
      header="Arborescence" 
      body={InfoBodyTemplate}
      ></Column>
      <Column 
      field="created_at" 
      header="Date de création" 
      body={dateBodyTemplate} 
      sortable
      
      />
      {isMaitreOrAdmin() && <Column body={actionBodyTemplate}></Column>}
    </DataTable>
  );
};

export default DataTableSite;
